import Vue from 'vue';
import dayjs from 'dayjs';
import Vuelidate from 'vuelidate';
import BootstrapVue from 'bootstrap-vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { recaptchaSiteKey, mediaUrl } from '@/config';

Vue.use(Vuelidate);

Vue.use(VueReCaptcha, {
    siteKey: recaptchaSiteKey,
    loaderOptions: {
        autoHideBadge: true
    }
});

Vue.use(BootstrapVue);
Vue.prototype.$toaster = function(message, options = {}) {
    this.$bvToast.toast(message, {
        title: 'Success!',
        variant: 'success',
        solid: true,
        ...options
    });
};

Vue.prototype.$toasterError = function(message = null) {
    this.$bvToast.toast(message || 'Something went wrong', {
        title: 'Error!',
        variant: 'danger',
        solid: true
    });
};

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

Vue.prototype.$dayjs = dayjs;

Vue.prototype.$downloadFile = (href, name, blank = false) => {
    const fileLink = document.createElement('a');

    fileLink.href = href;
    fileLink.setAttribute('download', name);

    if (blank) {
        fileLink.setAttribute('target', '_blank');
    }

    fileLink.click();
};

Vue.prototype.$getFileUrl = file => {
    if (!file) {
        return '';
    }

    const { type, date, filename, extension } = file;

    return `${mediaUrl}/${type}s/${date}/${filename}.${extension}`;
};
